var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.62 48.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M43.16,39.14c-2.59,0-5.21,0-7.8,0a1,1,0,0,1-1-1c0-1.61.33-1,1.95-1,4.62,0,9,0,13.66,0,5.08,0,8.89-4.7,8.78-9.76a8.27,8.27,0,0,0-5.85-7.8,1.29,1.29,0,0,1-1-1,9.24,9.24,0,0,0-10.73-7.8c-1.7.24-3.5-.07-4.87,1-.42.31-.81.42-1,0C33.22,6.61,28.32,4,22.68,4A13.13,13.13,0,0,0,10,15.73a8.94,8.94,0,0,0,0,2.92c.09.46.39.85,0,1a9.67,9.67,0,0,0-6.83,8.78,8.8,8.8,0,0,0,8.78,8.78c5,0,9.69,0,14.64,0a.87.87,0,0,1,1,.74.89.89,0,0,1,0,.23c0,1.43.46,1-1,1H12.92C6.32,39.14.77,34,1.21,27.43c.28-4.13,2.18-6.84,5.86-8.78.4-.21,1-.5,1-1C8,9.73,12.93,3.48,20.72,2.07A15.5,15.5,0,0,1,36.33,8.9c.38.58.33.26,1,0C44.12,6.18,52,10.57,53.89,17.68c.11.43.56-.21,1,0,4.27,2,6.42,7.22,5.85,11.7-.64,5-3.94,8.83-8.78,9.76a14.25,14.25,0,0,1-2.92,0C47.07,39.12,45.1,39.14,43.16,39.14Z",
    transform: "translate(-1.19 -1.85)",
    fill: "#098abd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M30.48,25.48c-2.32,2.33-4.69,4.64-6.83,6.83-.43.43-.53.48-1,0-1.1-1.18-1.13-.83,0-2,2.78-2.79,5-6,7.8-8.78.35-.35.56-.42,1,0,3,3.06,6.7,6.73,9.75,9.75.33.33.39-.32,0,0s-1.45,2-2,2-.58-1.55-1-2l-4.87-4.87-1-1c-.19.27,0,.74,0,1,0,7.57,0,15.84,0,23.41,0,.62-.34,0-1,0-1.45,0-1,.45-1-1V26.46C30.45,26.26,30.48,26,30.48,25.48Z",
    transform: "translate(-1.19 -1.85)",
    fill: "#098abd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.f8c0ee82506930989fd809bf86937b5b.svg";
export { ForwardRef as ReactComponent };